$(document).on('vue-loaded', function () {
    $('.item-collection-grid .item').each(function() {
        $item = $(this);
        addHoverStates($item);
    });

    $('.card').each(function() {
        $item = $(this);
        addHoverStates($item);
    });

    function addHoverStates(item) {
        item.find('.hover-toggle').on('mouseenter', function() {
            item.addClass('hover');
        });
        item.on('mouseleave', function() {
            item.removeClass('hover');
        })
    }
});